module.exports = __webpack_public_path__ + "media/evolve/assets/icons/fontawesome/solid/chevron-up-81bc4e1ff873d441c12501d6e04a11b5.svg";